import { gql } from "@/services/httpAdapter";
import { ChangeRequestResponseFragment } from "../common/fragments";

export const onSubmitPayrollToHR = gql`
	subscription onSubmitPayrollToHR($locationId: String, $payPeriodId: String) {
		onSubmitPayrollToHR(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			updated {
				_id
				status
				position
				statusDate
				companyId
				displayId
				providerPayPeriodId
				submitter {
					_id
					fullName
				}
				dateRange
			}
		}
	}
`;

export const onUpdatePayrollSubmitStatus = gql`
	subscription onUpdatePayrollSubmitStatus($locationId: String, $payPeriodId: String) {
		onUpdatePayrollSubmitStatus(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			updated {
				id
				status
				errors
			}
		}
	}
`;

export const onCreateChangeRequest = gql`
	subscription onCreateChangeRequest(
		$locationId: String
		$commissionCycleId: String
		$payPeriodId: String
		$userId: String
		$position: String
	) {
		onCreateChangeRequest(
			locationId: $locationId
			commissionCycleId: $commissionCycleId
			payPeriodId: $payPeriodId
			userId: $userId
			position: $position
		) {
			...ChangeRequestResponse
		}
	}
	${ChangeRequestResponseFragment}
`;

export const onUpdateChangeRequest = gql`
	subscription onUpdateChangeRequest(
		$locationId: String
		$commissionCycleId: String
		$payPeriodId: String
		$userId: String
		$position: String
	) {
		onUpdateChangeRequest(
			locationId: $locationId
			commissionCycleId: $commissionCycleId
			payPeriodId: $payPeriodId
			userId: $userId
			position: $position
		) {
			...ChangeRequestResponse
		}
	}
	${ChangeRequestResponseFragment}
`;

export const onCreateAdjustment = gql`
	subscription onCreateAdjustment($locationId: String, $payPeriodId: String) {
		onCreateAdjustment(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			payPeriodId
			adjustments {
				_id
				amount
				checkNumber
				adjustmentType
				createdBy {
					_id
					fullName
				}
				createdOn
				description
				lastModifiedBy
				lastModifiedOn
				recipient {
					_id
					fullName
				}
			}
		}
	}
`;

export const onDeleteAdjustment = gql`
	subscription onDeleteAdjustment($locationId: String, $payPeriodId: String) {
		onDeleteAdjustment(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			payPeriodId
			adjustments {
				_id
				amount
				checkNumber
				adjustmentType
				createdBy {
					_id
					fullName
				}
				createdOn
				description
				lastModifiedBy
				lastModifiedOn
				recipient {
					_id
					fullName
				}
			}
		}
	}
`;

export const onUpdateAdjustment = gql`
	subscription onUpdateAdjustment($locationId: String, $payPeriodId: String) {
		onUpdateAdjustment(locationId: $locationId, payPeriodId: $payPeriodId) {
			locationId
			payPeriodId
			adjustments {
				_id
				amount
				checkNumber
				adjustmentType
				createdBy {
					_id
					fullName
				}
				createdOn
				description
				lastModifiedBy
				lastModifiedOn
				recipient {
					_id
					fullName
				}
			}
		}
	}
`;

export const onApproveAllWashouts = gql`
	subscription onApproveAllWashouts($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
		onApproveAllWashouts(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			statusSetBy
			statusSetOn
			positionStatus {
				position
				status
			}
		}
	}
`;

export const onUpdateCommissionCycleToFinalizingProcess = gql`
	subscription onUpdateCommissionCycleToFinalizingProcess($locationId: String!, $_id: String!) {
		onUpdateCommissionCycleToFinalizingProcess(locationId: $locationId, _id: $_id) {
			_id
			locationId
			status
			inFinalizingProcess
			finalizingByUserId
			title
			startDate
			endDate
			dataUpdatedAt
			payPeriods {
				_id
				title
				intervalCode
				startDate
				endDate
				inReview
				positionStatus {
					position
					status
				}
				payPeriodProviders {
					status
					providerPayPeriodId
				}
				nextCCId
				previousCCId
				status
			}
		}
	}
`;
